<template>
  <div class="gla-auth-forbidden gla-auth-ui-surface">
    <div
      class="gla-auth-forbidden__avatar"
      :style="photoUrl ? `background-image: url(${photoUrl})` : ''"
      role="img"
      :aria-label="email || 'User'"
    />
    <div v-if="email" class="gla-auth-forbidden__email">{{ email }}</div>
    <div class="gla-auth-forbidden__message" v-html="messageHtml" />
    <button type="button" class="gla-auth-forbidden__btn" @click="$emit('sign-out')">
      {{ signOutLabel }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    email?: string;
    photoUrl?: string;
    /** Plain text; newline characters become line breaks in the message. */
    message: string;
    signOutLabel?: string;
  }>(),
  {
    signOutLabel: 'Sign out',
  },
);

defineEmits<{
  'sign-out': [];
}>();

const messageHtml = computed(() => {
  const escaped = props.message
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  return escaped.replace(/\n/g, '<br>');
});
</script>

<style scoped>
.gla-auth-forbidden {
  display: flex;
  box-sizing: border-box;
  width: 100vw;
  min-width: 100vw;
  max-width: 100vw;
  height: 100vh;
  min-height: 100vh;
  margin: 0;
  overflow: auto;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px;
}

.gla-auth-forbidden__avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background-color: #ababab;
  background-size: cover;
  background-position: center;
  margin-bottom: 8px;
}

.gla-auth-forbidden__email {
  margin-top: 8px;
  margin-bottom: 24px;
  font-size: 15px;
  color: #334155;
}

.gla-auth-forbidden__message {
  color: #dc2626;
  text-align: center;
  max-width: 320px;
  line-height: 1.45;
  font-size: 15px;
}

.gla-auth-forbidden__btn {
  margin-top: 28px;
  padding: 8px 16px;
  border: 1px solid #000;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
}

.gla-auth-forbidden__btn:hover {
  background: #f1f5f9;
}
</style>
